export default {
  metaInfo: {
    title: "구성원관리",
  },
  created() {
    if (this.$store.getters["auth/tokenPayload"]().type === "member") {
      return this.$router.push("/my/info");
    }
  },
  data() {
    return {
      members: [],
      totalCount: 1,
      p: 1,
      perPage: 6,
      q: "",
    };
  },
  filters: {
    approvedToKor(status) {
      switch (status) {
        case "pending":
          return "대기";
        case "approved":
          return "승인";
        case "refused":
          return "거절";
      }
    },
  },
  computed: {
    totalPagination() {
      return Math.ceil(this.totalCount / this.perPage);
    },
  },

  methods: {
    async search() {
      this.p = 1;
      await this.fetch();
    },
    async fetch() {
      try {
        const result = await this.$store.dispatch(
          "users/biz_manager_member_info",
          {
            page: this.p,
            perPage: this.perPage,
            q: encodeURI(this.q),
          }
        );

        this.members = result.members;
        if (result.count === 0) {
          this.totalCount = 1;
        } else {
          this.totalCount = result.count;
        }
      } catch (error) {
        console.error(error);
        return alert("에러가 발생하였습니다");
      }
    },
    async updateMemberApproval(memberId, status) {
      if (!memberId || !status) return;
      try {
        const result = await this.$store.dispatch(
          "users/biz_manager_member_approval",
          {
            _id: memberId,
            status: status,
          }
        );
        if (!result.success) return alert("에러가 발생하였습니다");
        this.members = result.members;

        this.totalCount === 0
          ? (this.totalCount = 1)
          : (this.totalCount = result.count);
      } catch (error) {
        console.error(error);
        return alert("에러가 발생하였습니다");
      }
      this.fetch();
    },
    pagination(val) {
      const totalPage = this.totalPagination;
      if (val == -1 && this.p == 1) {
        alert("첫 번째 페이지 입니다");
        return;
      }

      if (val == 1 && this.p == totalPage) {
        alert("마지막 페이지 입니다");
        return;
      }

      const newP = parseInt(this.p, 10) + val;
      this.p = newP;
    },
  },
  watch: {
    p() {
      this.fetch();
    },
  },
  async mounted() {
    if (this.$route.query.page) this.p = this.$route.query.page;
    await this.fetch();
  },
};
